<template>
  <RouterLink :to='computedTo' v-bind='attrs'>
    <slot />
  </RouterLink>
</template>

<script setup>

import { computed, useAttrs } from 'vue';
import { getOrganisationId, isSuperAdmin } from '@/kernel/session';

const props = defineProps({
  to: {
    type: [String, Object],
    required: true
  }
});

const attrs = useAttrs();

const computedTo = computed(() => {
  const organisationId = getOrganisationId();

  if (!isSuperAdmin() || !organisationId) {
    return props.to;
  }

  if (typeof props.to === 'string') {
    return {
      path: props.to,
      query: {
        organisationId
      }
    }
  } else if (typeof props.to === 'object') {
    return {
      ...props.to,
      query: {
        ...props.to.query,
        organisationId
      }
    }
  }

  return props.to;
});

</script>
